import t from 'react-translate';

import PusherChannelNames from 'shared/services/pusher-channel-names';
import { AppDispatch } from 'redux/store';
import { setProgramCloningStatus } from 'redux/actions/mentoring-programs';
import { addAlertMessage } from 'redux/actions/alert-messages';
import { AlertMessageType } from 'redux/schemas/app/alert-message';

import {
  Event,
  EventList,
  EventType,
  ProgramCloningEvent,
} from './event-types';
import { configureChannel } from './utils';

type CloneEventsConfig = {
  getProgramHref: (programId: number) => string;
};

const buildCloneEvents = ({ getProgramHref }: CloneEventsConfig): EventList => [
  {
    name: EventType.PROGRAM_CLONING_COMPLETED,
    handler: (event: Event, dispatch: AppDispatch) => {
      const { sourceProgramId, targetProgramId, targetProgramName } = event as ProgramCloningEvent;
      [sourceProgramId, targetProgramId].forEach((programId) => {
        if (programId) {
          dispatch(setProgramCloningStatus({ programId, isBeingCloned: false }));
        }
      });
      dispatch((innerDispatch, getState) => {
        const state = getState() as any;
        const programName = (
          targetProgramName
          || state.models?.mentoringPrograms?.[targetProgramId]?.name
          || ''
        );

        innerDispatch(addAlertMessage({
          type: AlertMessageType.SUCCESS,
          header: t.FORM.SUCCESS_BANG(),
          duration: Infinity,
          customElement: {
            component: 'AlertMentoringProgramCloningMessage',
            props: {
              programHref: targetProgramId ? getProgramHref(targetProgramId) : undefined,
              name: programName,
            },
          },
        }));
      });
    },
  }, {
    name: EventType.PROGRAM_CLONING_FAILED,
    handler: (event: Event, dispatch: AppDispatch) => {
      const { sourceProgramId, targetProgramId } = event as ProgramCloningEvent;
      [sourceProgramId, targetProgramId].forEach((programId) => {
        if (programId) {
          dispatch(setProgramCloningStatus({ programId, isBeingCloned: false }));
        }
      });
      dispatch(addAlertMessage({
        type: AlertMessageType.ERROR,
        header: t.FORM.OOPS(),
        message: t.FORM.ERROR_SOMETHING_WRONG_SHORT(),
      }));
    },
  },
];

const setupCloneMentorshipProgramEventsListener = (
  targetProgramId: number,
  dispatch: AppDispatch,
  config: CloneEventsConfig,
) => {
  const channelName = PusherChannelNames.mentoringProgramChannel(targetProgramId);
  return configureChannel(channelName, buildCloneEvents(config), dispatch);
};

export default setupCloneMentorshipProgramEventsListener;
